/*@ngInject*/
const NavigationRepository = function (baseRepository, currentSubmissionModel) {

    angular.extend(this, baseRepository);

    this.getNavigationItems = function (submissionId) {
        var url = '/rest/NavigationItem/?submissionId=' + submissionId + '&registrationIdentifier=/Submission/' + submissionId;

        currentSubmissionModel.addRegistration(url);

        return this.get(url);
    };
};

angular.module('gw-um-submission')
    .service('navigationRepository', NavigationRepository);
